import { motion } from "framer-motion";
import { EASE } from "@/components/motion/Reveal";

export const SpecTable = ({ specs, dark = false }) => (
  <dl className={`divide-y ${dark ? "divide-white/10" : "divide-ink/10"}`} data-testid="spec-table">
    {specs.map((s, i) => (
      <motion.div
        key={s.label}
        initial={{ opacity: 0, x: -16 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: i * 0.06, ease: EASE }}
        className="flex items-baseline justify-between gap-6 py-4"
        data-testid={`spec-row-${i}`}
      >
        <dt className={`font-mono text-[11px] uppercase tracking-widest ${dark ? "text-white/50" : "text-ink/50"}`}>{s.label}</dt>
        <dd className={`text-right font-display text-xl font-bold ${dark ? "text-white" : "text-ink"}`}>{s.value}</dd>
      </motion.div>
    ))}
  </dl>
);
